import { render, staticRenderFns } from "./MyRoles.vue?vue&type=template&id=89802be6"
import script from "./MyRoles.vue?vue&type=script&lang=js"
export * from "./MyRoles.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports